// extracted by mini-css-extract-plugin
module.exports = {"support__section":"support_support__section__WE8Jq"};